import { ArticleParagraph2, Lock16 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';

export const BookedOverlay: React.FC = () => {
  return (
    <div className={style['container']}>
      <div className={style['icon']}>
        <Lock16 />
      </div>
      <ArticleParagraph2 fontWeight="700">Квартира забронирована</ArticleParagraph2>
    </div>
  );
};
